import { render, staticRenderFns } from "./AddToCartCheck.vue?vue&type=template&id=68054182&"
var script = {}
import style0 from "./add-to-cart-check.scss?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports